import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {DeliveryPointService} from 'app/blocks/service/api/delivery-point.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IDeliveryPoint} from 'app/blocks/model/delivery-point.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {DeliveryPoint} from 'app/blocks/model/delivery-point.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class DeliveryPointResource extends AbstractEntityResource<IDeliveryPoint> {
    constructor(deliveryPointService: DeliveryPointService, router: Router) {
        super(
            Resource.DELIVERY_POINTS,
            deliveryPointService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.DELIVERY_POINTS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.DELIVERY_POINTS),
            (entity?) => new DeliveryPoint(entity),
            (entity) => entity.code
        );
    }
}
